import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { City } from '@/types/domain/city';

export function HomeCityFilters({
  cities,
  isLoading,
  selectedCityId,
  onSelectCity,
}: {
  cities: City[];
  isLoading: boolean;
  selectedCityId: string | null;
  onSelectCity: (cityId: string | null) => void;
}) {
  const handleCityClick = (cityId: string) => {
    onSelectCity(selectedCityId === cityId ? null : cityId);
  };

  return (
    <section className="container pb-6">
      <div className="scrollbar-none flex gap-2 overflow-x-auto pb-1">
        {isLoading ? (
          <span className="text-muted-foreground text-sm">Carregando cidades...</span>
        ) : (
          <>
            <Button
              variant={selectedCityId === null ? 'default' : 'outline'}
              size="sm"
              onClick={() => onSelectCity(null)}
              className={cn(
                'text-foreground hover:bg-primary hover:text-primary-foreground h-9 shrink-0 rounded-full px-4 text-sm font-medium whitespace-nowrap transition-colors',
                selectedCityId === null ? 'text-white' : null,
              )}
            >
              Todas
            </Button>

            {cities.map((city) => (
              <Button
                key={city.id}
                variant={selectedCityId === city.id ? 'default' : 'outline'}
                size="sm"
                onClick={() => handleCityClick(city.id)}
                className={cn(
                  'text-foreground hover:bg-primary hover:text-primary-foreground h-9 shrink-0 rounded-full px-4 text-sm font-medium whitespace-nowrap transition-colors',
                  selectedCityId === city.id ? 'text-white' : null,
                )}
              >
                {city.name}
              </Button>
            ))}
          </>
        )}
      </div>
    </section>
  );
}
